module.exports = __webpack_public_path__ + "img/Rosace_papier_pour_mariage.7042d5d.jpg";